import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch, RootState } from "./store";

/** Typed dispatch that accepts RTK thunks (react-redux 9 default does not). */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
